import { render, staticRenderFns } from "./DetailsModalNew.vue?vue&type=template&id=6c596c9f&"
import script from "./DetailsModalNew.vue?vue&type=script&lang=js&"
export * from "./DetailsModalNew.vue?vue&type=script&lang=js&"
import style0 from "./DetailsModalNew.vue?vue&type=style&index=0&id=6c596c9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports